
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import {Link} from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
Quand faut-il laver les mains? Aussi souvent que possible. Avant de préparer des aliments et avant de manger, après être allé aux toilettes, après avoir reniflé, éternué ou toussé, chaque fois que vous rentrez chez vous, après avoir utilisé les transports publics, avant d'insérer et de retirer des lentilles de contact, après avoir été en contact avec des animaux.
    </p>
    <p>L'OMS montre dans une vidéo comment se laver correctement les mains:</p>
    <AutofitIFrame src='https://www.youtube.com/embed/3PmVJQUCm4E' width='560' height='328' mdxType="AutofitIFrame" />
    <p className='ps'><i>P.S.:</i>
 Dans la <Link href='https://www.youtube.com/watch?time_continue=1&v=gw2Ztu0H0YY&feature=emb_logo' allowWordWrap mdxType="Link">vidéo de prévention sur le lavage des mains de l'Office fédéral de la santé publique (OFSP)</Link>, il y a une étape qui n'est pas correcte. Saurez-vous trouver l'erreur ?
 </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;